// extracted by mini-css-extract-plugin
module.exports = {"LongText":"style-module__LongText___DqUeT","fieldWrapper":"style-module__fieldWrapper___8nS2F","TextField":"style-module__TextField___BXfZf"};